import {Box} from 'src/design/atoms/Box';
import {SimpleGrid} from 'src/design/atoms/SimpleGrid';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import type {JobHazardAnalysisResponse} from 'src/api/ProactApiClient';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {FormViewDate} from 'src/app/forms/FormViewDate/FormViewDate';
import {FormViewRow} from 'src/app/forms/FormViewRow/FormViewRow';

export interface JobHazardAnalysisFormViewProps {
  formData?: JobHazardAnalysisResponse;
}

export const JobHazardAnalysisFormView: React.FC<
  JobHazardAnalysisFormViewProps
> = ({formData}) => (
  <Stack gap="md">
    <SectionCard title="General">
      <Box p="md">
        <FormViewRow label="Subject" value={formData?.subjectName} />
        <FormViewRow label="Location(s)" value={formData?.location} />
      </Box>
    </SectionCard>

    <SectionCard title="Schedule">
      <Box p="md">
        <SimpleGrid cols={{base: 1, lg: 2}} verticalSpacing="0">
          <FormViewDate label="Work Start" value={formData?.workStartDate} />
          <FormViewDate label="Work Finish" value={formData?.workFinishDate} />
        </SimpleGrid>
      </Box>
    </SectionCard>

    {(formData?.creator || formData?.approver || formData?.safetyReviewer) && (
      <SectionCard title="Personnel">
        <Box p="md">
          <SimpleGrid cols={{base: 1, lg: 2}} verticalSpacing="0">
            <FormViewRow label="Creator" value={formData?.creator?.name} />
            <FormViewRow
              label="Department"
              value={formData?.creator?.department?.code}
            />
          </SimpleGrid>
          <SimpleGrid cols={{base: 1, lg: 2}} verticalSpacing="0">
            <FormViewRow label="Approver" value={formData?.approver?.name} />
            <FormViewRow
              label="Safety Reviewer"
              value={formData?.safetyReviewer?.name}
            />
          </SimpleGrid>
        </Box>
      </SectionCard>
    )}
  </Stack>
);
